export default "__VITE_ASSET__BjyakqHc__"